/* @flow */
/**
 * Internal dependencies
 */
import {
	INCREMENT_PROGRESS,
	USER_CONFIRM_SOUND,
	VIDEO_LOADED,
	VIDEO_PLAY,
	VIDEO_RESET,
} from '../constants/action-types';

/**
 * Flow
 */
import type {
	VideoLoadedAction,
	VideoPlayAction,
	VideoResetAction,
} from '../actions/video';
import type {
	UserConfigSoundAction,
	UserIncrementProgressAction,
} from '../actions/user';

type VideoReducerActions =
	VideoLoadedAction |
	VideoPlayAction |
	VideoResetAction |
	UserIncrementProgressAction |
	UserConfigSoundAction;

export type VideoState = {|
	loaded: boolean,
	playing: boolean,
	started: boolean,
|};

/**
 * Initial state
 */
export const initialState = {
	loaded: false,
	playing: false,
	started: false,
};

/**
 * Reducer
 */
export default function theme( state: VideoState = initialState, action: VideoReducerActions ) : VideoState {
	switch ( action.type ) {
		case INCREMENT_PROGRESS:
		case USER_CONFIRM_SOUND: {
			let playing = false;

			if ( state.loaded ) {
				playing = true;
			}

			return {
				...state,
				playing,
			};
		}

		case VIDEO_LOADED:
			return {
				...state,
				loaded: action.payload,
			};

		case VIDEO_PLAY:
			return {
				...state,
				playing: action.payload,
				started: true,
			};

		case VIDEO_RESET:
			return {
				...initialState,
				loaded: action.payload,
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/video.js